import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'
import { AuditFilter, AuditLogsResponse } from '@/types'

const AUDIT_QUERY_KEY = 'audit'

export const useAuditLogs = (filters: AuditFilter = {}) => {
  return useQuery<AuditLogsResponse>({
    queryKey: [AUDIT_QUERY_KEY, filters],
    queryFn: async () => {
      const params = new URLSearchParams()
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value))
        }
      })

      const { data } = await api.get(`/audit?${params.toString()}`)
      return data
    },
  })
}
